/**
 * Created by User on 22/02/2016.
 */
export default Logger;

function Logger() {

}

Logger.log = function(message) {
  if (Logger._logCallback) {
    Logger._logCallback(message);
  }
};

Logger.initialize = function(logCallback) {
  if (typeof logCallback === 'function') {
    Logger._logCallback = logCallback;
  }
};

Logger._logCallback = null;
